const normalizeAllergen = (value) => {
    if (typeof value !== 'string')
        return null;
    const trimmed = value.trim();
    return trimmed || null;
};
const resolveIngredientId = (ingredient) => {
    return String(ingredient.id || ingredient._id || ingredient.name || '').trim();
};
const addAllergens = (target, allergens) => {
    for (const allergen of allergens || []) {
        const normalized = normalizeAllergen(allergen);
        if (normalized) {
            target.add(normalized);
        }
    }
};
export function collectProductConfigAllergens(input) {
    const collected = new Set();
    const removedIds = new Set((input.removedIngredientIds || []).map((id) => String(id).trim()).filter(Boolean));
    addAllergens(collected, input.productAllergens);
    const baseSources = [
        ...(input.baseIngredients || []),
        ...(input.removableIngredients || []).filter((entry) => typeof entry === 'object' && entry !== null)
    ];
    const processedBaseIds = new Set();
    for (const ingredient of baseSources) {
        const ingredientId = resolveIngredientId(ingredient);
        if (!ingredientId || processedBaseIds.has(ingredientId)) {
            continue;
        }
        processedBaseIds.add(ingredientId);
        if (removedIds.has(ingredientId)) {
            continue;
        }
        addAllergens(collected, ingredient.allergens);
    }
    const extraById = new Map();
    for (const extra of input.extraIngredients || []) {
        const extraId = resolveIngredientId(extra);
        if (extraId) {
            extraById.set(extraId, extra);
        }
    }
    for (const extraId of input.selectedExtraIds || []) {
        const extra = extraById.get(String(extraId).trim());
        if (extra) {
            addAllergens(collected, extra.allergens);
        }
    }
    for (const ingredientId of Object.values(input.selectedMandatoryByGroup || {})) {
        const normalizedId = String(ingredientId || '').trim();
        if (!normalizedId)
            continue;
        for (const group of input.mandatoryIngredientGroups || []) {
            const match = group.ingredients?.find((ingredient) => resolveIngredientId(ingredient) === normalizedId);
            if (match) {
                addAllergens(collected, match.allergens);
            }
        }
    }
    return Array.from(collected);
}
